import { createTestId } from '../../common/selectors';

export const underwriterCreditsScreenSelector = createTestId(`offering-underwriter-credits`);
